import { Component, Input } from '@angular/core';
import { WorkflowStatsDto } from '@savvy/view-definition';
import { ContextIdDto } from '@savvy/quickbooks';

@Component({
  selector: 'app-view-workflow-stats-panel',
  templateUrl: 'viewWorkflowStatsPanel.component.html',
  styleUrls: ['commonPanel.component.scss']
})
export class ViewWorkflowStatsPanelComponent {

  @Input() workflowStatsDto: WorkflowStatsDto;
  @Input() contextIdDto: ContextIdDto;
}

